import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import axios from 'axios'
import store from './store/index'
import 'animate.css'
import './assets/global.css'
import './assets/index.css'
import './assets/fonts/iconfont.css'
import './assets/css/hover.css'
import 'swiper/dist/js/swiper'
import 'swiper/dist/css/swiper.css'
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'lzvEWd2tQaghMEwumUg4PqVsX03R67Q8'
})
import * as animated from 'animate.css'
Vue.use(animated)
Vue.config.productionTip = false
Vue.prototype.$http=axios
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
